import { useRouter } from 'next/router';
import { FindStateType, ModalStateType, LoginJoin, SocialLogin } from '@components/loginModal';
import { useUserInfo } from '@repository/auth/useUserInfo';
import Title from '@components/jobflexLoginModal/login/title';
import LoginForm from './LoginForm';
import { JobflexQueryType } from '@domain/constant/JobflexQueryType';
import DateUtil from '@utils/date/util';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './resumeLogin.module.scss';

const cx = classnames.bind(styles);

const ApplyInfo = () => {
  const router = useRouter();
  const {
    query: { companyName, jobNoticeName, applyStartDate, applyEndDate },
  } = router;

  if (!(companyName && jobNoticeName && applyStartDate && applyEndDate)) return null;

  const getDate = (date: string) => new Date(+date.slice(0, 4), +date.slice(4, 6) - 1, +date.slice(6, 8));

  const convertStartDate = getDate(applyStartDate as string);
  const convertEndDate = getDate(applyEndDate as string);

  const getLeftDays = () => DateUtil.getLeftDays(DateUtil.getNow(), convertEndDate);
  const getDateRange = getLeftDays() > 0 ? `D-${getLeftDays()}` : 'D-day';

  const getApplyDate = () =>
    `${DateFormat.format(new Date(convertStartDate), 'yyyy-MM-dd')} ~ ${DateFormat.format(
      new Date(convertEndDate),
      'yyyy-MM-dd',
    )}`;

  return (
    <div className={cx('applyInfoArea')}>
      <ul className={cx('applyInfo')}>
        <li>
          <span>기업명</span>
          <span>{companyName}</span>
        </li>
        <li>
          <span>공고명</span>
          <span>{jobNoticeName}</span>
        </li>
        <li>
          <span>접수기간</span>
          <span className={cx('leftDays')}>{getDateRange}</span>
          <span className={cx('applyDate')}>{getApplyDate()}</span>
        </li>
      </ul>
    </div>
  );
};

interface ResumeLoginProps {
  setModalState: (state: ModalStateType) => void;
  setFindState: (state: FindStateType) => void;
}

const ResumeLogin = ({ setModalState, setFindState }: ResumeLoginProps) => {
  const router = useRouter();
  const {
    asPath,
    query: { type },
  } = router;
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;

  const getQuery = () => {
    if (!type) return null;
    return {
      type: type as JobflexQueryType,
    };
  };

  return (
    <div className={cx('resumeLogin')}>
      <Title />
      <ApplyInfo />
      <LoginForm setFindState={setFindState} setModalState={setModalState} />
      {!isLogin && (
        <div className={cx('socialJoinBtnArea')}>
          <SocialLogin redirectUrl={asPath} type={'MODAL'} />
          <LoginJoin label={<>회원가입</>} query={getQuery()} />
        </div>
      )}
    </div>
  );
};

export default ResumeLogin;
